<template>
  <div>
    <template v-for="(item, itemI ) in fixedValue">
      <v-divider style="padding-bottom: 2rem;" :key="`${itemI}start`" />
      <Field
        v-for="sattribute in attribute.fields"
        :key="`${itemI}-${sattribute.name}`"
        :attribute="sattribute"
        :canEdit="canEdit && !sattribute.from_relation"
        :isCopied="isCopied"
        :disabled="isCopied"
        :value="valueOf(item, sattribute)"
        :values="item"
        :loading="sattribute.from_relation && loadingEntries"
        @input="setSubValue(itemI, sattribute.name, $event)"
      />
      <v-row :key="`${itemI}end`">
        <v-col cols="4" class="pa-0 pt-2">
          <v-subheader style="height: auto; min-height: 48px;"></v-subheader>
        </v-col>
        <v-col class="pt-2">
          <v-btn
            fab
            dark
            :title="attribute.delete_label[$i18n.locale]"
            small
            color="danger"
            class="mr-1"
            v-if="!isCopied"
            @click="del(itemI)"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            v-if="related && !isCopied"
            fab
            dark
            :title="attribute.edit_label[$i18n.locale]"
            small
            class="mr-1"
            @click="edit(itemI)"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <v-divider style="padding-bottom: 2rem;" />
    <v-row>
      <LabelCol :cols="labelCols" :attribute="attribute" />
      <v-col :cols="valueCols" class="pa-0">
        <v-row>
          <v-col class="pt-2">
            <v-subheader
              style="height: auto; min-height: 48px;"
            >{{attribute.add_label[$i18n.locale]}}</v-subheader>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-btn
              fab
              dark
              :title="attribute.add_label[$i18n.locale]"
              small
              color="primary"
              class="mr-1"
              @click.stop="add"
              :disabled="!canEdit"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-if="related" v-model="dialog">
      <v-card>
        <v-card-title class="headline">{{attribute.add_label[$i18n.locale]}}</v-card-title>
        <v-card-text>
          <v-form v-model="isNewEntryValid">
            <v-row class="pb-3">
              <LabelCol :cols="labelCols" :attribute="{'label_pl': 'Wybierz', 'label_en': 'Select'}" />
              <v-autocomplete
                v-model="editedEntryId"
                :items="fieldsSelect"
                item-value="id"
                item-text="text"
                :loading="loadingEntries"
                outlined
                :rules="[value => !!value || this.$i18n.t('default.requiredField')]"
              />
            </v-row>
            <Fields
              v-if="dialog"
              :attributes="entryAttributes"
              :canEdit="!savingEntry"
              :disabled="isCopied"
              :loading="savingEntry"
              v-model="editedEntryValue"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="!isNewEntryValid"
            :loading="savingEntry"
            @click="saveEntry"
          >Zapisz</v-btn>
          <v-btn @click="editedEntryId=undefined" :disabled="savingEntry">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import LabelCol from './LabelCol';
import Fields from './Fields';
import Field from './Field';

import { DICTS } from '@/dicts';

export default {
  components: {
    LabelCol,
    Fields,
    Field
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    value: {
      required: true
    }
  },
  data() {
    return {
      entriesList: [],
      entries: {},
      loadingEntries: false,
      editedEntryValue: undefined,
      loadingEntrySchema: false,
      editedEntryId: undefined,
      editedEntryAdding: undefined,
      editedEntryIndex: undefined,
      entryAttributes: [],
      savingEntry: false,
      isNewEntryValid: false
    };
  },
  computed: {
    fixedValue() {
      let v = this.value;
      if (!v) {
        return [];
      } else {
        return v;
      }
    },
    related() {
      return Boolean(this.attribute.related_to_api_name);
    },
    dialog() {
      return Boolean(this.editedEntryValue);
    },
    fieldsSelect() {
      let arr;
      if (this.attribute.related_name_field_translated) {
        arr = this.entriesList.map(e => ({
          id: e.id,
          text: e.wlasciciel && e.wlasciciel[this.$i18n.locale]
        }));
      } else {
        arr = this.entriesList.map(e => ({
          id: e.id,
          text: e.wlasciciel
        }));
      }
      arr.push({
        id: 'new',
        text: this.attribute.new_label[this.$i18n.locale]
      });
      return arr;
    }
  },
  watch: {
    dialog(newv, oldv) {
      if (newv && !oldv) {
        this.downloadEntries();
      }
    },
    editedEntryId(newv, oldv) {
      if (newv !== oldv) {
        if (newv === undefined) {
          this.editedEntryValue = undefined;
        } else if (newv === 'new') {
          this.editedEntryValue = {};
        } else {
          this.editedEntryValue = { ...this.entries[newv] };
        }
      }
    }
  },
  methods: {
    add() {
      if (this.related) {
        this.downloadEntries();
        this.editedEntryId = 'new';
        this.editedEntryAdding = true;
        this.editedEntryIndex = undefined;
      } else {
        const newItem = {};
        for (const field of this.attribute.fields) {
          if ('default' in field) {
            newItem[field.name] = field.default;
          }
        }
        this.setValue([...this.fixedValue, newItem]);
      }
    },
    del(index) {
      // TODO: deleting
      let v = [...this.fixedValue];
      v.splice(index, 1);
      this.setValue(v);
    },
    edit(index) {
      let id = this.fixedValue[index].id;
      this.editedEntryId = id;
      this.editedEntryValue = { ...this.entries[id] };
      this.editedEntryAdding = false;
      this.editedEntryIndex = index;
    },
    setValue(value) {
      this.$emit('input', value);
    },
    setSubValue(index, key, val) {
      let v = [...this.fixedValue];
      v[index] = {
        ...this.fixedValue[index],
        [key]: val
      };
      this.setValue(v);
    },
    valueOf(item, sattribute) {
      if (sattribute.from_relation) {
        let entry = this.entries[item.id];
        return entry && entry[sattribute.name];
      } else {
        return item[sattribute.name];
      }
    },
    async downloadEntries() {
      let api_name = this.attribute.related_to_api_name;
      this.loadingEntries = true;
      let r = await axios.get(`/${api_name}`);
      let entriesList = r.data[api_name];
      let entries = {};
      this.entriesList = entriesList;
      entriesList.forEach(entry => {
        entries[entry.id] = entry;
      });
      this.entries = entries;
      this.loadingEntries = false;
    },
    async downloadEntrySchema() {
      let api_name = this.attribute.related_to_api_name;
      this.loadingEntrySchema = true;
      let r = await axios.get(`/${api_name}/schema`);
      this.entryAttributes = r.data[api_name].default;
      this.loadingEntrySchema = false;
    },
    async saveEntry() {
      try {
        let api_name = this.attribute.related_to_api_name;
        this.savingEntry = true;
        let entryValue = { ...this.editedEntryValue };
        delete entryValue.id;
        let r;
        let adding;
        let id;
        if (this.editedEntryId === 'new') {
          adding = true;
          r = await axios.post(`/${api_name}`, entryValue);
          id = r.data[api_name];
        } else {
          adding = false;
          id = this.editedEntryId;
          r = await axios.put(`/${api_name}/${id}`, entryValue);
        }
        this.editedEntryId = undefined;
        entryValue.id = id;
        this.entries[id] = entryValue;
        if (this.editedEntryAdding) {
          if (this.attribute.add_uuid) {
            this.setValue([...this.fixedValue, { id, __uuid: uuidv4() }]);
          } else {
            this.setValue([...this.fixedValue, { id }]);
          }
        } else {
          this.setSubValue(this.editedEntryIndex, 'id', id);
        }
        this.savingEntry = false;
      } catch {
        this.$root.$emit('showSnackbar', this.$i18n.t(`default.error`));
        this.savingEntry = false;
      }
    }
  },
  async created() {
    let api_name = this.attribute.related_to_api_name;
    if (api_name) {
      this.downloadEntries();
      this.downloadEntrySchema();
    }
  }
};
</script>
